import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import { useForBindingId } from '../../../forBinding';

export interface ExportFertilizersParams {
	format: 'pdf' | 'xlsx';
	filter?: string;
	category?: string | string[];
	nature?: string | string[];
	origin?: string | string[];
	manufacturer?: string | string[];
	sortAsc?: boolean;
}

export function useExportFertilizers() {
	const forBinding = useForBindingId();
	return useMutation({
		mutationFn: async ({
			format,
			filter,
			category,
			nature,
			origin,
			manufacturer,
			sortAsc,
		}: ExportFertilizersParams) => {
			try {
				const params = new URLSearchParams();
				params.set('format', format);
				if (forBinding) params.set('forBinding', forBinding);
				if (filter) params.set('filter', filter);
				if (sortAsc !== undefined) params.set('sortAsc', String(sortAsc));

				const categories = Array.isArray(category) ? category : category ? [category] : [];
				const natures = Array.isArray(nature) ? nature : nature ? [nature] : [];
				const origins = Array.isArray(origin) ? origin : origin ? [origin] : [];
				const manufacturers = Array.isArray(manufacturer)
					? manufacturer
					: manufacturer
						? [manufacturer]
						: [];

				categories.forEach((item) => params.append('category', item));
				natures.forEach((item) => params.append('nature', item));
				origins.forEach((item) => params.append('origin', item));
				manufacturers.forEach((item) => params.append('manufacturer', item));

				const response = await api.get<Blob>('/products/fertilizer/export', {
					params,
					responseType: 'blob',
				});
				const disposition = response.headers['content-disposition'] as string | undefined;
				const filename = disposition?.match(/filename="?([^";]+)"?/i)?.[1];
				return { file: response.data, filename: filename ?? `fertilizantes.${format}` };
			} catch (error) {
				throw toApiError(error, 'Erro ao exportar fertilizantes');
			}
		},
	});
}
